import { API } from '../utils/config'

export function SubscribeAPI(token, data) {
    return API.post('/subscriptions/new/', data, { headers: { Authorization: 'Token ' + token } })
}
export function VerifyCoupon(coupon) {
    return API(`/subscriptions/coupons/${coupon}/`)
}
